var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DEFAULT_AUTH0_CLIENT } from './constants';
import { getJSON } from './http';
import { createQueryParams } from './utils';
export function oauthToken(_a, worker) {
    var { baseUrl, timeout, audience, scope, auth0Client, useFormData } = _a, options = __rest(_a, ["baseUrl", "timeout", "audience", "scope", "auth0Client", "useFormData"]);
    return __awaiter(this, void 0, void 0, function* () {
        const body = useFormData
            ? createQueryParams(options)
            : JSON.stringify(options);
        return yield getJSON(`${baseUrl}/oauth/token`, timeout, audience || 'default', scope, {
            method: 'POST',
            body,
            headers: {
                'Content-Type': useFormData
                    ? 'application/x-www-form-urlencoded'
                    : 'application/json',
                'Auth0-Client': btoa(JSON.stringify(auth0Client || DEFAULT_AUTH0_CLIENT))
            }
        }, worker, useFormData);
    });
}
//# sourceMappingURL=api.js.map